import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetPaymentMadeAtom } from "../../store/paymentMadeAtom";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import StatusBadge from "../../generals/StatusBadge";


function PaymentMadeScroll({ onSelection, viewItemDetails }) {
  const paymentMadeAtom = GetPaymentMadeAtom();
  const [tableData, setTableData] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    setTableData(paymentMadeAtom.payment_info?.map((ele) => ({ ...ele, checked: false })));
  }, [paymentMadeAtom]);

  const onCheckboxClick = async (e, index) => {
    let element = tableData[index];
    tableData[index] = { ...element, checked: e.target.checked };
    await setTableData([...tableData]);
    onSelection(tableData);
  };

  return (
    <section className="mt-4 border border-gray-200 rounded-lg bg-white shadow-sm">
      {tableData?.map((info, index) => (
        <div
          key={index}
          onClick={() => viewItemDetails(info?.payment_ref_no)}
          className={`flex items-center p-3 border-b border-gray-200 hover:bg-gray-50 cursor-pointer transition-colors duration-200 ${
            Number(id) === info?.payment_ref_no ? 'bg-blue-50' : ''
          }`}
        >
          <div className="flex items-center space-x-3 w-full">
            <input
              type="checkbox"
              checked={info?.checked || false}
              onChange={(e) => onCheckboxClick(e, index)}
              className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <div className="flex-1">
              <div className="font-semibold text-gray-800 text-sm">{info?.payment_number}</div>
              <div className="text-sm text-gray-500 italic">{info?.reference_number}</div>
              <div className="text-sm text-gray-600">{formatCustomNumber(info?.total_payment_amount)}</div>
            </div>
            <StatusBadge
              statusId={info?.payment_status_id}
              statusName={info?.payment_status_name}
            />
            {/* <div className="text-sm font-semibold text-gray-700">{info?.Bag_Quantity}</div> */}
          </div>
        </div>
      ))}
    </section>
  );
}

export default PaymentMadeScroll;